module.exports = __webpack_public_path__ + "img/3.1.37d2548d.png";